import {
	AbstractControl,
	ValidationErrors,
	ValidatorFn,
	NG_VALIDATORS,
	Validator,
} from "@angular/forms";

import * as _ from "google-libphonenumber";
import { Input, Directive } from "@angular/core";
import { Subscription } from "rxjs";

export function MobileValidator(countryControlName: string): ValidatorFn {
	return (mobileControl: AbstractControl): ValidationErrors | null => {
		const countryControl = mobileControl.root.get(countryControlName);
		const mobileNumber: string = normalizePhoneDigits(mobileControl.value);

		if (countryControl) {
			const subscription: Subscription =
				countryControl.valueChanges.subscribe(() => {
					mobileControl.updateValueAndValidity();
					subscription.unsubscribe();
				});
		}

		if (mobileNumber === "") {
			return null;
		}

		if (
			mobileNumber.startsWith("+") ||
			mobileNumber.startsWith("0") ||
			mobileNumber.startsWith("00")
		) {
			return {
				validCountryPhone: true,
			};
		}

		try {
			const phoneUtil = _.PhoneNumberUtil.getInstance();
			const region = countryControl.value;
			const number = phoneUtil.parse(mobileNumber, region);
			const isValidNumber = phoneUtil.isValidNumber(number);
			const nrType = phoneUtil.getNumberType(number);
			const dialCode = phoneUtil.getCountryCodeForRegion(region);

			if (mobileNumber.startsWith(dialCode)) {
				return {
					validCountryPhone: true,
				};
			}

			if (isValidNumber && nrType === _.PhoneNumberType.MOBILE) {
				return null;
			}
		} catch (e) {
			return {
				validCountryPhone: true,
			};
		}

		return {
			validCountryPhone: true,
		};
	};
}

export function normalizePhoneDigits(value: unknown): string {
	return String(value ?? "")
		.replace(/[۰-۹]/g, (digit) =>
			String(digit.charCodeAt(0) - "۰".charCodeAt(0))
		)
		.replace(/[٠-٩]/g, (digit) =>
			String(digit.charCodeAt(0) - "٠".charCodeAt(0))
		)
		.trim();
}

@Directive({
	selector:
		"[appMobile][formControlName],[appMobile][formControl],[appMobile][ngModel]",
	standalone: true,
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: MobileDirective,
			multi: true,
		},
	],
})
export class MobileDirective implements Validator {
	@Input()
	countryControlName: string;

	@Input()
	numberType: _.PhoneNumberType;

	validate(phoneControl: AbstractControl): ValidationErrors | null {
		return MobileValidator(this.countryControlName)(phoneControl);
	}
}
